var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-chip',{attrs:{"status":_vm.status,"statuses":_vm.types}})}
var staticRenderFns = []

export { render, staticRenderFns }